<template>
   <div class="btnWrap">
      <div @click="sweepCode" :class="CashReceiptRight ? 'sweepCode' : 'sweepCode disabled'">
         <span>扫码支付</span>
      </div>
      <div v-show="isAllowCashPay" @click="cashPayFunc" :class="ScanCodePaymentRight ? 'cash' : 'cash disabled'">
         <span>现金支付</span>
      </div>
   </div>
</template>

<script>
import { setWXConfig, scanQRCode } from "@/js/frameworkUtils.js";
export default {
   name: 'PayTypeSelect',
   props: {
      /**
       * 校验扫码支付
       */
      checkSweepCode: Function,
      /**
       * 订单号，传入该订单号视为支付，没有则是创建订单后支付
       */
      orderNo: String
   },
   data() {
      return {
         CashReceiptRight:
            this.$utils.getRight("Sys.view.SellTicket.Container", "CashReceipt") ===
            true, // 现金支付权限
         ScanCodePaymentRight:
            this.$utils.getRight(
               "Sys.view.SellTicket.Container",
               "ScanCodePayment"
            ) === true, // 扫码支付权限
         isAllowCashPay: this.$utils.getSysParams("IsAllowCashPay") != "0", //是否允许现金支付
         payCode: '', // 支付码
         OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      }
   },
   methods: {
      /**
       * 扫码支付
       */
      sweepCode() {
         // 存在需要校验扫码支付的函数，则调用进行校验
         if (this.checkSweepCode) {
            if (!this.checkSweepCode()) return;
         }
         // 校验扫码支付权限
         if (!this.ScanCodePaymentRight) {
            this.$toast("没有扫码支付权限");
            return;
         }
         scanQRCode()
            .then((res, type) => {
               console.log("扫码回调", res, type);
               var a = res.resultStr;
               // app环境扫码直接返回code，微信环境需要通过resultStr获取
               this.scanCreateTicket(a || res);
            })
            .catch((err) => {
               this.$toast(err);
            });
      },
      /**
       * 现金支付
       */
      cashPayFunc() {
         // 现金支付 --- 创建订单后
         // 支付订单 -- 现金
         this.TicketOrderPayDo("CashPay", this.orderNo, null);
      },
      /**
       * 扫码支付订单
       * @param {*} scanResult 
       */
      scanCreateTicket(scanResult) {
         //扫码失败
         if (scanResult == "" || scanResult == null || scanResult.length == 0) {
            this.$toast.fail("扫码失败！");
            return;
         }
         // 扫码后 -- 创建订单 -- 支付 -- 打印
         this.payCode = scanResult;
         if (this.payCode) {
            // 扫码支付 --- 创建订单后
            // 支付订单 -- 扫码
            this.TicketOrderPayDo(
               "AllinpayScanPayBSC",
               this.orderNo,
               this.payCode);
         }
      },

      /**
       * 支付订单
       * @param {*} PayTypeCode 支付方式
       * @param {*} OrderNo 订单号
       * @param {*} payCode 支付码
       */
      TicketOrderPayDo(PayTypeCode, OrderNo, payCode) {
         let params = {
            PayTypeCode: PayTypeCode,
            OrderNo: OrderNo,
            OperGID: this.OperObj.GID, //操作员GID
            OperCode: this.OperObj.UserCode, //操作员代码
            OperName: this.OperObj.UserName, //操作员名称
         };
         this.$http
            .post(
               this.$api.onTicketOrderPayDo,
               this.$qs.stringify({
                  model: params,
                  authcode: payCode,
               })
            )
            .then((res) => {
               if (res.success) {
                  // this.$toast("支付成功");
                  // this.TicketOrderCommit();
                  setTimeout(() => {
                     this.$router.back(-1);
                  }, 500);
               } else {
                  this.$toast("支付失败：" + res.msg);
               }
            })
            .catch((err) => {
               this.$dialog.alert({
                  title: "提示",
                  message: err,
               });
            });
      },

      // TicketOrderCommit() {
      //    let param = {
      //       AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
      //       OrderNo: this.orderNo,
      //       PayNo: this.payCode,
      //       OperGID: this.OperObj.GID, //操作员GID
      //       OperCode: this.OperObj.UserCode, //操作员代码
      //       OperName: this.OperObj.UserName, //操作员名称
      //    }
      //    this.$http
      //       .post(this.$api.submitTicketOrder, param)
      //       .then(res => {
      //          if (res.success) {
      //             setTimeout(() => {
      //                this.$router.back(-1);
      //             }, 500);
      //          }
      //       })
      // }
   },
   created() {
      // 如果是微信环境下，需要配置微信jsapi
      if (this.$utils.getIsWxClient()) {
         setWXConfig();
      }
   }
}
</script>

<style lang="less" scoped>
.btnWrap {
   display: flex;
   justify-content: space-between;
   margin-top: 0.2rem;
   margin-bottom: 0.2rem;

   div {
      width: 100%;
      margin-top: 0.2rem;
      text-align: center;

      span {
         padding: 0.2rem;
         background-color: rgb(40, 145, 231);
         border-radius: 0.1rem;
         color: #fff;
         display: inline-block;
      }
   }

   .disabled {
      opacity: 0.5;
   }
}
</style>